module.exports = __webpack_public_path__ + "img/2.2dc3c66d.gif";